import React, { Component, Fragment, useState } from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";

import format from "string-template";
import firebase from "firebase";
import { withRouter } from "react-router-dom";
import WYSIWYG from "../ui/formFields/WYSIWYG";
import Repeater from "../ui/formFields/Repeater";
import FieldSet from "../ui/formFields/Fieldset";
import File from "../ui/formFields/File";
import Input from "../ui/formFields/Input";
import Select from "../ui/formFields/Select";
import SelectRelational from "../ui/formFields/SelectRelational";
import Search from "../ui/formFields/Search";
import TreeSelect from "../ui/formFields/TreeSelect";
import ShortId from "../ui/formFields/ShortId";
import SwipeableViews from "react-swipeable-views";
import {
  throttle,
  set,
  get,
  reduce,
  map,
  result,
  cloneDeep,
  clone,
  isUndefined,
} from "lodash";
import {
  Tooltip,
  IconButton,
  Button,
  AppBar,
  Box,
  Switch,
  FormControlLabel,
  Grid,
  Tabs,
  Tab,
  Avatar,
} from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { createStyles, withStyles } from "@material-ui/core/styles";
import Toolbar from "../Toolbar";
import { withSnackbar } from "notistack";

const styles = createStyles({
  tabsBar: {
    top: 54,
    zIndex: 1,
  },
});

const formFields = {
  treeSelect: TreeSelect,
  search: Search, //TreeSelect,
  text: Input,
  number: Input,
  file: File,
  selectRelational: SelectRelational,
  select: Select,
  shortId: ShortId,
  switch: ({ label, ...props }) => (
    <Box pt={2}>
      <FormControlLabel
        label={label}
        control={
          <Switch
            checked={Boolean(props.value)}
            color="primary"
            onChange={props.onChange}
          />
        }
        labelPlacement="start"
      />
    </Box>
  ),
  wysiwyg: WYSIWYG,
  repeater: Repeater,
  fieldset: FieldSet,
};

class Form extends Component {
  state = {
    isSaving: false,
    schema: this.props.schema || {},
    formData: this.props.formData || {},
    formErrors: null,
    currentTabIndex: 0,
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   return this.state.currentTabIndex !== nextState.currentTabIndex;
  // }

  // static getDerivedStateFromProps(props, state) {
  //   if (props.match.params.entryId !== 'new' && !size(state.formData)) {
  //     return {
  //       ...state,
  //       formData: props.formData
  //     };
  //   }

  //   return null;
  // }

  handleTabChange = (currentTabIndex) => {
    this.setState({ currentTabIndex });
    document.querySelector("#stack").scrollTop = 0;
  };

  handleInputChange = (key) => (e) => {
    result(e, "persist");
    this.updateFormData(key, e);
  };

  // updateFormData = throttle((key, e) => {
  updateFormData = (key, e) => {
    let value = "";
    if (
      get(e, "target.type") === "checkbox" &&
      !isUndefined(get(e, "target.checked"))
    ) {
      value = get(e, "target.checked");
    } else if (!isUndefined(get(e, "target.value"))) {
      value = get(e, "target.value");
    } else if (!isUndefined(get(e, "data"))) {
      value = get(e, "data");
    } else if (!isUndefined(e)) {
      value = e;
    }

    const formData = cloneDeep(this.state.formData);
    set(formData, key, value);
    this.setState({ formData });
    // });
  };

  save = async ({ close = false } = {}) => {
    if (this.state.isSaving) {
      return;
    }

    try {
      const ref = firebase.firestore().collection(this.props.schema.ref);
      const { formData } = this.state;
      const isNew = this.props.match.params.entryId === "new";
      this.setState({ isSaving: true });

      const docId = isNew ? ref.doc().id : this.props.match.params.entryId;
      await ref.doc(docId).set({
        ...formData,
        _sys: {
          ...(formData._sys || {}),
          createDate: get(formData, "_sys.createDate", Date.now()),
          lastUpdated: Date.now(),
          lastUser: firebase.auth().currentUser.uid,
        },
      });

      if (isNew) {
        this.props.history.replace(
          this.props.location.pathname.replace("new", close ? "" : docId)
        );
      } else if (close) {
        this.props.history.replace(
          this.props.location.pathname.replace(`/${docId}`, "")
        );
      }

      this.props.enqueueSnackbar("Save complete", {
        variant: "success",
      });
    } catch (e) {
      this.props.enqueueSnackbar("Error", {
        variant: "error",
      });
      console.error(e);
    } finally {
      this.setState({ isSaving: false });
    }
  };

  renderTabs = () => {
    const { classes } = this.props;
    return this.props.schema.tabs ? (
      <AppBar position="sticky" color="default" className={classes.tabsBar}>
        <Tabs
          value={this.state.currentTabIndex}
          onChange={(e, index) => this.handleTabChange(index)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="Tabs"
        >
          {map(this.props.schema.tabs, (tab) => (
            <Tab label={tab} key={`tab-${tab}`} />
          ))}
        </Tabs>
      </AppBar>
    ) : null;
  };

  renderComponents = (tab) =>
    reduce(
      this.props.schema.properties,
      (acc, { layout, ...field }, key) => {
        const objectKey = this.props.keyPrefix
          ? `${this.props.keyPrefix}.${key}`
          : key;

        if (!tab || field.tab === tab) {
          const Component = formFields[field.component];
          // field.component = undefined;
          if (Component) {
            acc.push(
              <Grid
                key={objectKey}
                item
                {...layout}
                style={{ display: field.hidden ? "none" : "block" }}
              >
                <Component
                  keyPrefix={objectKey}
                  formData={
                    this.props.keyPrefix
                      ? this.props.formData
                      : this.state.formData
                  }
                  fullWidth
                  {...field}
                  id={objectKey}
                  // defaultValue={
                  //   ['select', 'repeater', 'files', 'text'].includes(
                  //     field.component
                  //   )
                  //     ? undefined
                  //     : get(this.state.formData, objectKey)
                  // }
                  value={
                    // ['select', 'repeater', 'file', 'text'].includes(
                    //   field.component
                    // )
                    //   ? get(this.state.formData, objectKey) || ''
                    //   : undefined
                    get(
                      this.props.keyPrefix
                        ? this.props.formData
                        : this.state.formData,
                      objectKey,
                      ""
                    )
                  }
                  onChange={
                    this.props.handleInputChange
                      ? this.props.handleInputChange(objectKey, field.transform)
                      : this.handleInputChange(objectKey, field.transform)
                  }
                  updateForm={
                    this.props.handleInputChange
                      ? this.props.handleInputChange
                      : this.handleInputChange
                  }
                  component={undefined}
                />
              </Grid>
            );
          } else {
            acc.push(
              <Grid
                key={key}
                item
                {...layout}
              >{`No component for ${field.component}`}</Grid>
            );
          }
        }
        return acc;
      },
      []
    );

  renderSwipableViews = () => (
    <SwipeableViews
      index={this.state.currentTabIndex}
      onChangeIndex={(index) => this.handleTabChange(index)}
    >
      {map(this.props.schema.tabs, (tab, index) => (
        <Box key={`swipe-${tab}`} p={4}>
          {(this.state.currentTabIndex === index || true) && (
            <Grid
              container
              spacing={4}
              // hidden={index !== this.state.currentTabIndex}
            >
              {this.renderComponents(tab)}
            </Grid>
          )}
        </Box>
      ))}
    </SwipeableViews>
  );

  render() {
    const isNew = this.props.match.params.entryId === "new";
    const previewUrl = get(this.props, "schema.previewUrl");

    return (
      <Fragment>
        {!this.props.keyPrefix && (
          <Toolbar style={{ top: 0 }}>
            {!isNew &&
              previewUrl &&
              map(previewUrl, (link, key) => (
                <Box mr={1}>
                  <Tooltip title="View on Staging">
                    <Button
                      color="primary"
                      component="a"
                      href={format(link, {
                        ...this.props.formData,
                        ...this.props.match.params,
                      })}
                      target="_blank"
                      startIcon={<Visibility />}
                    >
                      {key}
                    </Button>
                  </Tooltip>
                </Box>
              ))}
            <Box mr={1}>
              <Button
                disabled={this.state.isSaving}
                variant="outlined"
                color="primary"
                onClick={() => {
                  this.save({ close: true });
                }}
              >
                Save & Close
              </Button>
            </Box>
            <Button
              disabled={this.state.isSaving}
              variant="contained"
              color="primary"
              onClick={() => {
                this.save();
              }}
            >
              Save
            </Button>
          </Toolbar>
        )}
        {this.renderTabs()}
        {this.props.schema.tabs && this.renderSwipableViews()}
        {!this.props.schema.tabs && (
          <Box p={this.props.withPadding ? 4 : 1} width={1}>
            <Grid container spacing={4}>
              {this.renderComponents()}
            </Grid>
          </Box>
        )}
      </Fragment>
    );
  }
}

export default connect(
  () => ({}),
  null
)(withStyles(styles)(withRouter(withSnackbar(hot(module)(Form)))));
